module.exports = __webpack_public_path__ + "29f8d63554677981f82066000bd4aad4.svg";